import _ from 'lodash'
import { FETCH_REFUND } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_REFUND:
      return action.payload
    default:
      return state
  }
}
